import { styled } from '@mui/material';

export const Price = styled('div')({
  marginTop: 8,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontWeight: 'bold',
});
